export const PAGE_SIZE = 16;
export const SORT_OPTIONS = {
  0: 'SEARCH_NO_SORT',
  2: 'SEARCH_SORT_BY_NAME',
  1: 'SEARCH_SORT_BY_PART_NUMBER'
};

export const SORT_OPTIONS_KEYS = ['0', '2', '1'];
export const PLP_ESPOT_NAME = 'CATSAS_SUBCLP_ESPOT';
